module.exports = __webpack_public_path__ + "img/spider.bea473ba.gif";